import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { FeatureFlag, isFeatureEnabled } from '@core/constants';

export const featureFlagGuard: CanMatchFn = (route) => {
  const feature = route.data?.['feature'] as FeatureFlag | undefined;

  if (feature && isFeatureEnabled(feature)) {
    return true;
  }

  return inject(Router).createUrlTree(['/pages/404']);
};
